

<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>
<div *ngIf="privilegesView==='VAMD'&&isActive('/app/create-manual-cart')" class="outside-container mt-4">
    <div  class="box-container ">
        <div class="container">
            <div class="title ">

              <div  class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Create Manual Cart</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <!-- <button *ngIf="showCredit" class="btn btn-outline-primary btn-sm " ><img src="assets/images/Add_24.png"></button> -->
                 
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div *ngIf="privilegesView==='VAMD'" class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-12  " >
                      <div class="col-md-12 d-flex justify-content-start">
                        <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickRetrieval()"     [ngClass]="{'activity' :showPnrRetrieval}">PNR Retrieval</span></span>

                        <span *ngIf="isActive('/app/create-manual-cart')" class=" d-flex justify-content-center mb-4 mb-2" style="margin-left: 8px; height: 22px"> <span class=" btns"  (click)="onClickGeneratePNR()"     [ngClass]="{'activity' :showGeneratePNR}">Air <!--Create Cart--></span></span>
                        <span *ngIf="isActive('/app/create-manual-cart')" class=" d-flex justify-content-center mb-4 mb-2" style="margin-left: 8px; height: 22px"> <span class=" btns"  (click)="onClickHotel()"     [ngClass]="{'activity' :showHotelCart}">Hotel</span></span>


                    </div>
                      
                    </div>

                   <div class="col-md-12" style="height:70vh; overflow-y: auto;">
                     
                    <div *ngIf="showHotelCart" class="col-md-12 card" style="min-height: 100%;" >
<app-hotel-manual-cart></app-hotel-manual-cart>

</div>
                      <div *ngIf="showPnrRetrieval" class="col-md-12 card" style="min-height: 100%;" >

                        <app-pnr-retrive></app-pnr-retrive>
                        <div *ngIf="isActive('/app/flight')" style="text-align: start;">
                          <h3 style="margin-left: 10px;">Important Info:</h3>
                          <ul>
                              <li>
                                  Generate the PNR on your GDS &amp; queue it to myPartner PCC - <strong>8UO0</strong> &amp; queue - <strong>70</strong>.
                                  Use the command <code>QEB/8UO0/70</code> on the GDS to queue.
                              </li>
                              <li>
                                  Please ensure fare is saved in the PNR (i.e., Filed Fare <strong>(FF)</strong> exists) before importing.
                                  Save using the command <code>FQ &amp; ER</code> on GDS.
                              </li>
                              <li>
                                  You can check the deal sheet here.
                              </li>
                              <li>
                                  Retrieve the PNR, make the payment, and ticket the PNR completely online.
                              </li>
                              <li>
                                  The Travel Agent Partner acknowledges that all the bookings which are confirmed pursuant to the usage of the PNR Queuing feature 
                                  will not be considered while calculating the completed travel bookings under the Hero program on the myPartner platform.
                              </li>
                          </ul>
                      </div>
                        </div>
                        <div *ngIf="showGeneratePNR" class="col-md-12  " style="min-height: 100%;" >
                        <app-flight ></app-flight>
                          <!-- <app-generate-pnr></app-generate-pnr> -->
                          </div>
                    
                    </div>
                </div>

               